<template>
<div class="hero-wrapper" :class="{ inset: type == 'inset' }">
  <div class="hero" :style="`backgroundImage: url(${imageUrl}`">
    <div class="tag" v-if="this.dishesNum"> <img class="icon-cloche" src="@assets/images/icon-cloche.png" /> {{ this.daysNum }} dishes </div>
    <div class="tag" v-if="this.daysNum"> <img class="icon-calendar" src="@assets/images/icon-calendar.png" /> {{ this.daysNum }} days </div>
  </div>
  <div class="hero-title" v-if="this.title">
    <h2>{{ this.title }}</h2>
  </div>
</div>
</template>

<script>
import store from '@state/store';

export default {
  components: {},
  props: {
    daysNum: {
      type: Number,
      required: false,
    },
    dishesNum: {
      type: Number,
      required: false,
    },
    imageUrl: {
      type: String,
      required: true,
    },
    isEmbed: {
      type: Boolean,
    },
    meal: {
      type: Object,
      required: false,
    },
    type: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.hero-wrapper {
  margin-bottom: 1.5rem;

  .hero {
    align-items: flex-end;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    height: 23.7rem;
    justify-content: space-between;
    margin-bottom: 1.6rem;
    padding: 0.8rem;

    .tag {
      align-items: center;
      background-color: $color-meal-card-horizontal-tag-bg;
      border-radius: $size-hero-tag-border-radius;
      color: $color-meal-card-horizontal-tag-text;
      display: flex;
      font-size: 1.3rem;
      justify-content: center;
      padding: 0.6rem 1rem;

      .icon-cloche {
        height: 1.68rem;
        margin-right: 0.8rem;
        width: 2rem;
      }

      .icon-calendar {
        height: 1.7rem;
        margin-right: 0.8rem;
        width: 1.6rem;
      }
    }
  }

  .hero-title {
    color: $color-meal-card-horizontal-title;
    padding: 0 1.6rem;

    small {
      color: $color-meal-card-horizontal-subtitle;
      display: block;
      font-size: 75%;
    }
  }

  &.inset {
    .hero {
      border-radius: $base-border-radius;
      height: 16.1rem;
      margin: 1.2rem 2rem 1.6rem;
      padding: 0.8rem;
    }
  }
}
</style>
